'use client';

import React from 'react';
import { AlertCircle } from 'lucide-react';

export function LicenseSuspended() {
  return (
    <div className="min-h-screen bg-slate-950 flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full bg-slate-900 border border-red-900/50 rounded-2xl p-8 text-center shadow-2xl">
        <div className="w-20 h-20 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertCircle className="w-10 h-10 text-red-500" />
        </div>
        
        <h1 className="text-2xl font-bold text-white mb-2">Licencia Suspendida</h1>
        
        <p className="text-slate-400 mb-8">
          El acceso a este sistema ha sido suspendido. Por favor, comunícate con soporte de Kawrium Hub para regularizar tu situación.
        </p>

        <div className="p-4 bg-slate-950 rounded-lg border border-slate-800">
          <p className="text-sm text-slate-500 font-medium">LIVE MOTO — Sistema de Gestión</p>
        </div>
      </div>
    </div>
  );
}
